// BOB inventory is predominantly teal while the product photos show black; no
// other line has that mismatch.
const COLOR_DISCLAIMER_PRODUCT_IDS = new Set<number>([5, 6]);

export const COLOR_DISCLAIMER_TEXT =
  'Stroller color may vary and is not guaranteed to be black.';

export const COLOR_DISCLAIMER_BADGE_LABEL = 'Color Policy';

// The FAQ page and the BOB color-disclaimer modal both render this copy and
// must not drift apart, so neither one inlines its own wording.
export const COLOR_POLICY_FAQ = {
  q: 'Are your strollers the same colors as in the pictures?',
  a: "No. We've used pictures that offer the highest level of detail so our guests can see all of the great features our strollers have to offer. We purchase neutral colors that hold up best in the Florida sun. While we wish we could honor specific color requests, we are unable to guarantee a particular color choice.",
};

export const hasColorDisclaimer = (productId?: number): boolean =>
  typeof productId === 'number' && COLOR_DISCLAIMER_PRODUCT_IDS.has(productId);
